import React from "react";
import { Gift, RotateCcw } from "lucide-react";
import { formatPrice, resolveImg } from "../lib/api";
import { shortDate } from "../lib/shipping";

export function SendingNote({ item, testid }) {
  if (item.can_send === undefined || item.can_send === null || item.can_send >= item.quantity) return null;
  return (
    <span className="block text-xs text-[var(--terracotta)] mt-0.5" data-testid={testid}>
      {item.can_send === 0 ? "Sold out, so this one isn't coming" : `Sending ${item.can_send} of ${item.quantity}`}
    </span>
  );
}

export default function OrderAdjustments({ order }) {
  const swaps = order.swaps || [];
  const refunds = order.refunds || [];
  if (!swaps.length && !refunds.length) return null;
  return (
    <div className="space-y-3" data-testid={`order-adjustments-${order.id}`}>
      {swaps.length > 0 && (
        <div className="space-y-2">
          <p className="eyebrow">Added to your order instead</p>
          {swaps.map((w) => (
            <div key={w.id} className="flex items-center gap-3 text-sm" data-testid={`customer-swap-${w.id}`}>
              {w.image_url ? (
                <img src={resolveImg(w.image_url)} alt="" className="w-10 h-10 rounded-lg object-cover bg-[var(--muted)]" />
              ) : (
                <span className="w-10 h-10 rounded-lg bg-[var(--terracotta)]/10 flex items-center justify-center"><Gift className="w-4 h-4 text-[var(--terracotta)]" /></span>
              )}
              <span className="flex-1 text-[var(--ink-forest)]">{w.quantity} × {w.name}</span>
            </div>
          ))}
        </div>
      )}
      {refunds.map((r, i) => (
        <p key={i} className="text-sm text-[var(--ink-forest)] inline-flex items-center gap-2 w-full" data-testid={`customer-refund-${i}`}>
          <RotateCcw className="w-4 h-4 text-[var(--terracotta)]" />
          Refunded {formatPrice(r.amount)} on {shortDate(r.created_at)} to your card
        </p>
      ))}
    </div>
  );
}
